import { render } from "./verificationComponent.vue?vue&type=template&id=76f34bf6&scoped=true"
import script from "./verificationComponent.vue?vue&type=script&lang=js"
export * from "./verificationComponent.vue?vue&type=script&lang=js"

import "./verificationComponent.vue?vue&type=style&index=0&id=76f34bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f34bf6"]])

export default __exports__